import { LoadingIndicator } from '../common/components/loading-indicator';
import { FrAddEventPropertyBody } from './fr-add-event-property-body';
import { FrAddEventPropertyFooter } from './fr-add-event-property-footer';
import { FrAddEventPropertyHeader } from './fr-add-property-page-header';
import { FrPage } from '../fr-page-layout/fr-page';
import { useIntegratedForm } from '../forms/use-integrated-form';

export function FrAddEventPropertyPage() {
    const { query: eventQuery } = useIntegratedForm();

    if (eventQuery.isFetching) {
        return <LoadingIndicator />;
    }

    return (
        <FrPage>
            <FrAddEventPropertyHeader />
            <FrAddEventPropertyBody />
            <FrAddEventPropertyFooter />
        </FrPage>
    );
}
